import {
    ICubeSourceDataSource,
    ICubeSourceMetricsPolicy,
    IMetricPolicyOptions,
} from "../../PA.HyperRectangle.Core/CubeSource.IF";
import { ICellMetric } from "../../PA.HyperRectangle.Core/PA.HyperRectangle.IF";
import { WB_ModelRow } from "../../PA.Core/PAdbSchemaRows";
import * as _ from "lodash";
import { ModelUtils } from "../../PA.Model.Services/ModelUtils";
import { SimulatorPredictorMetric } from "../../PA.Simulation.BusinessObjects/SimulatorPredictorMetric";

export class ModelMetricPolicy implements ICubeSourceMetricsPolicy {
    get PolicyId(): string {
        return "ModelPredictors";
    }

    async getMetrics(DataSource: ICubeSourceDataSource, options: IMetricPolicyOptions): Promise<ICellMetric[]> {
        // Get the Model, Create Predictor Metrics with the correct prefix.

        let wbModelId: number = options?.WB_MODEL_ID || 0;
        let wbModelRow: WB_ModelRow = options?.WB_ModelRow;
        if (!_.isEmpty(wbModelRow)) {
            wbModelId = wbModelRow.cif.WB_MODEL_ID;
        }

        if (!(wbModelId > 0)) {
            return [];
        }

        //--
        const arrMdlPreds = await ModelUtils.getModelPredictorList(wbModelId, { bSkipCache: false });
        const rv: ICellMetric[] = [];
        _.forEach(arrMdlPreds, (pred) => {
            const mp = new SimulatorPredictorMetric(pred, false, DataSource.Alias + "_", { aliasId: DataSource.Alias });
            rv.push(mp);
        });
        return rv;
    }
}
